import { LazyImage } from "@dmm-com/rocket-web-ui-library";
import * as Styled from "./style";
import { sendTrackingClickCommon } from "~/lib/tracking/events";
type MenuItemProps = {
  title: string;
  src: string;
  alt: string;
  href: string;
};
export const MenuItem = ({ title, src, alt, href }: MenuItemProps) => {
  return (
    <Styled.DivItemWrapper>
      <Styled.AnchorItem
        href={href}
        onClick={() => {
          title === "総合トップへ"
            ? sendTrackingClickCommon({ clickEventName: "dmmtv_navigation", viaTargetId: "dmmtop" })
            : sendTrackingClickCommon({ clickEventName: "dmmtv_navigation", viaTargetId: "help" });
        }}
      >
        <LazyImage src={src} width="32px" height="32px" alt={alt} />
        <Styled.SpanText>{title}</Styled.SpanText>
      </Styled.AnchorItem>
    </Styled.DivItemWrapper>
  );
};
